export function isAnySwitchStep(step: { _type?: unknown } | undefined): boolean {
	return step?._type === 'SwitchAutomationStep' || step?._type === 'BehaviorSwitchAutomationStep';
}

export enum AutomationsReportingTableColumn {
	Communication = 'Communication',
	Message = 'Message',
	Policy = 'Policy',
	Progress = 'Progress',
	Recipient = 'Recipient',
	StatusAndActions = 'Engagement / Actions',
}
